import React, { useEffect, useState } from 'react';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { Solution } from './components/Solution';
import { ProductSection } from './components/ProductSection';
import { Bonuses } from './components/Bonuses';
import { Testimonials } from './components/Testimonials';
import { About } from './components/About';
import { IsForYou } from './components/IsForYou';
import { Offer } from './components/Offer';
import { FAQ } from './components/FAQ';
import { CTAButton, Section, Countdown, FadeIn } from './components/Shared';
export function App() {
  const [showSticky, setShowSticky] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 600) {
        setShowSticky(true);
      } else {
        setShowSticky(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="min-h-screen bg-cream text-charcoal font-sans selection:bg-sage/30 selection:text-charcoal overflow-hidden" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />

        <FadeIn data-id="element-3">
          <PainSection data-id="element-4" />
        </FadeIn>
        <FadeIn data-id="element-5">
          <Solution data-id="element-6" />
        </FadeIn>
        <FadeIn data-id="element-7">
          <ProductSection data-id="element-8" />
        </FadeIn>
        <FadeIn data-id="element-9">
          <Bonuses data-id="element-10" />
        </FadeIn>
        <FadeIn data-id="element-11">
          <Testimonials data-id="element-12" />
        </FadeIn>
        <FadeIn data-id="element-13">
          <About data-id="element-14" />
        </FadeIn>
        <FadeIn data-id="element-15">
          <IsForYou data-id="element-16" />
        </FadeIn>
        <FadeIn data-id="element-17">
          <Offer data-id="element-18" />
        </FadeIn>

        {/* Final CTA Section */}
        <FadeIn data-id="element-19">
          <Section className="text-center py-24 bg-cream-dark border-t border-beige-muted/50" data-id="element-20">
            <h2 className="font-playfair text-3xl md:text-5xl text-charcoal mb-6 leading-tight" data-id="element-21">
              El desarrollo de tu bebé no necesita perfección.
            </h2>
            <p className="font-playfair text-2xl md:text-3xl text-sage-dark italic mb-10" data-id="element-22">
              Solo pequeños momentos compartidos con amor.
            </p>

            <Countdown data-id="element-23" />

            <CTAButton className="text-lg px-12 py-5 shadow-xl" data-id="element-24">
              QUIERO EMPEZAR HOY
            </CTAButton>
          </Section>
        </FadeIn>

        <FadeIn data-id="element-25">
          <FAQ data-id="element-26" />
        </FadeIn>
      </main>

      {/* Footer */}
      <footer className="bg-white py-10 text-center border-t border-beige-muted" data-id="element-27">
        <p className="text-charcoal-light text-sm font-medium" data-id="element-28">
          © {new Date().getFullYear()} Estimulación Temprana Inteligente. Todos
          los derechos reservados.
        </p>
        <p className="text-charcoal-light/60 text-xs mt-4 max-w-3xl mx-auto px-6 leading-relaxed" data-id="element-29">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
      </footer>

      {/* Mobile Sticky CTA */}
      <div className={`fixed bottom-0 left-0 right-0 p-4 bg-white/95 backdrop-blur-md border-t border-beige-muted md:hidden z-50 transition-transform duration-300 shadow-[0_-4px_20px_rgba(0,0,0,0.05)] ${showSticky ? 'translate-y-0' : 'translate-y-full'}`} data-id="element-30">
        <CTAButton className="w-full py-3.5 text-sm shadow-md" data-id="element-31">
          QUIERO EMPEZAR HOY
        </CTAButton>
      </div>
    </div>;
}